import Text, { TextProps } from 'app/src/kit/Text'
import ChartLegendSymbol, { ChartLegendSymbolProps } from './ChartLegendSymbol'

export interface ChartLegendItemProps {
  label: string
  labelSize?: TextProps['$fontSize']
  labelColor?: TextProps['$color']
  style?: React.CSSProperties
  variant?: ChartLegendSymbolProps['variant']
  color?: ChartLegendSymbolProps['color']
  itemSize?: ChartLegendSymbolProps['size']
}

const ChartLegendItem: FC<ChartLegendItemProps> = ({
  label,
  variant = 'dot',
  color,
  labelSize,
  labelColor,
  style,
  itemSize
}) => {
  return (
    <Flex $alignItems='center' $gap={'sm'} style={style} $width={'max-content'}>
      <ChartLegendSymbol variant={variant} color={color} size={itemSize} />
      <Text $fontSize={labelSize} $color={labelColor}>
        {label}
      </Text>
    </Flex>
  )
}

export default ChartLegendItem
